import { render, staticRenderFns } from "./TopView.vue?vue&type=template&id=b25589b6&scoped=true"
import script from "./TopView.vue?vue&type=script&lang=js"
export * from "./TopView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25589b6",
  null
  
)

export default component.exports